import { useCallback, useEffect, useState } from "react";

export function useOtpTimer(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    setSeconds(initialSeconds);
  }, [initialSeconds]);

  useEffect(() => {
    const timerId = window.setInterval(() => {
      setSeconds((current) => (current > 0 ? current - 1 : 0));
    }, 1000);

    return () => window.clearInterval(timerId);
  }, []);

  const reset = useCallback((nextSeconds: number) => {
    setSeconds(nextSeconds);
  }, []);

  return {
    seconds,
    isExpired: seconds <= 0,
    reset,
  };
}
